import { createReducer, isAnyOf } from "@reduxjs/toolkit";
import { getAllowedUsersSuccessful, setRemoveUsersAccessDialogOpen, removeUsersAccessSuccessful, setGrantUsersAccessDialogOpen, editUsersAccessSuccessful, getNotAllowedUsersSuccessful, resetNotAllowedUsers, getAllUsersSuccessful, removeUsersAccess, editUsersAccess, getAllowedUsersFailure, } from "./users.actions";
import initialState from "./users.store";
export default createReducer(initialState, (builder) => {
    builder
        .addCase(getAllowedUsersSuccessful, (state, { payload }) => {
        state.allowedUsers = payload;
    })
        .addCase(getAllowedUsersFailure, (state) => {
        state.allowedUsers = [];
    })
        .addCase(getAllUsersSuccessful, (state, { payload }) => {
        state.allUsers = payload;
    })
        .addCase(getNotAllowedUsersSuccessful, (state, { payload }) => {
        state.notAllowedUsers = payload;
    })
        .addCase(resetNotAllowedUsers, (state) => {
        state.notAllowedUsers = [];
    })
        .addCase(removeUsersAccess, (state, { payload }) => {
        state.pendingUsers = payload.userIds;
    })
        .addCase(editUsersAccess, (state, { payload }) => {
        state.pendingUsers = payload.map(({ userId }) => userId);
    })
        .addCase(setRemoveUsersAccessDialogOpen, (state, { payload }) => {
        state.removeUserAccessDialogOpen = payload;
    })
        .addCase(setGrantUsersAccessDialogOpen, (state, { payload }) => {
        state.grantUserAccessDialogOpen = payload;
    })
        .addCase(editUsersAccessSuccessful, (state, { payload }) => {
        state.allowedUsers = [
            ...[...(state.allowedUsers ?? [])].filter(({ id }) => !payload.some((item) => item.id === id)),
            ...payload,
        ];
        state.grantUserAccessDialogOpen = false;
    })
        .addCase(removeUsersAccessSuccessful, (state, { payload }) => {
        state.allowedUsers = [...(state.allowedUsers ?? [])].filter(({ id }) => !payload.userIds.includes(id ?? ""));
        state.removeUserAccessDialogOpen = false;
    })
        .addMatcher(isAnyOf(removeUsersAccessSuccessful, editUsersAccessSuccessful), (state) => {
        state.pendingUsers = [];
    });
});
